import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { LICENSE_TYPES_DATA } from '../../constants/LicenseTypes';
import { LINKS_COLOR } from '../../theme';
import media from '../../utils/mediaQueries';

const Title = styled.div`
  font-size: 16px;
  font-weight: 800;
  line-height: 1.38;
  letter-spacing: 0.2px;
  margin-bottom: 3px;
`;

const TypeRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 32px;
  
  ${media.mobile`
    margin-bottom: 24px;
  `}
`;

const EditButton = styled.button`
  font-size: 12px;
  font-weight: bold;
  line-height: 1.17;
  color: ${LINKS_COLOR};
  padding: 7px;
  border: 1px solid ${LINKS_COLOR};
  border-radius: 6px;
  background: #fff;
  margin-left: 8px;
  
  &:hover {
    opacity: 0.8;
  }
  
  &:focus {
    outline: none;
    opacity: 0.8;
  }
`;

const ChosenLicenseType = ({ selectedLicenseType, onEditLicenseClick }) => (
  <div>
    <Title>Je souhaite passer l’examen suivant</Title>
    <TypeRow>
      <div>{`${LICENSE_TYPES_DATA[selectedLicenseType].abbr}. ${LICENSE_TYPES_DATA[selectedLicenseType].descr}.`}</div>
      <EditButton onClick={onEditLicenseClick} type="button">Modifier</EditButton>
    </TypeRow>
  </div>
);

ChosenLicenseType.propTypes = {
  selectedLicenseType: PropTypes.string.isRequired,
  onEditLicenseClick: PropTypes.func.isRequired,
};

export { ChosenLicenseType };
